"use strict";
var ndarray = require('ndarray');
var assign_1 = require('ndarray-ops-typed/lib/assign');
var compileMesher = require('greedy-mesher');
var Mesher = (function () {
    function Mesher(options) {
        if (options === void 0) { options = {}; }
        this.z = 0;
        this.u = 0;
        this.v = 0;
        this.d = 0;
        this.meshSlice = compileMesher({ order: [1, 0], append: this.append.bind(this) });
        var margin = options.margin || 0;
        this.padSize = 2 + margin;
        this.unpadSize = options.openEnd ? 2 : 1;
        this.planarOffset = 2 - this.unpadSize;
    }
    Mesher.prototype.pad = function (array) {
        var shape = [
            array.shape[0] + this.padSize,
            array.shape[1] + this.padSize,
            array.shape[2] + this.padSize,
        ];
        // TODO: Consider using typedarray-pool
        var padded = ndarray(new Int32Array(shape[0] * shape[1] * shape[2]), shape);
        var dest = padded.lo(1, 1, 1).hi(array.shape[0], array.shape[1], array.shape[2]);
        assign_1.default(dest, array);
        return padded.hi(array.shape[0] + 2, array.shape[1] + 2, array.shape[2] + 2);
    };
    Mesher.prototype.unpad = function (array) {
        return array.hi(array.shape[0] - this.unpadSize, array.shape[1] - this.unpadSize, array.shape[2] - this.unpadSize);
    };
    Mesher.prototype.computeSurface = function (d, buffer) {
        var u = (d + 1) % 3;
        var v = (d + 2) % 3;
        // Create slice
        var st = buffer.transpose(d, u, v).hi(buffer.shape[d], buffer.shape[u] - this.planarOffset, buffer.shape[v] - this.planarOffset);
        var slice = st.pick(0);
        var n = st.shape[0];
        this.d = d;
        this.u = v;
        this.v = u;
        // Generate slices
        for (var i = 0; i < n; ++i) {
            this.z = i;
            this.meshSlice(slice);
            slice.offset += st.stride[0];
        }
    };
    return Mesher;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Mesher;
//# sourceMappingURL=Mesher.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/~/@voxeline/mesher/lib/Mesher.js
 ** module id = 940
 ** module chunks = 0
 **/